import * as React from 'react';
import { useSelector } from 'react-redux';

import placeOffer from './assets/place_offer.svg';
import { trackServiceClick, trackServiceShowNew } from './tracking';
import { Carousel } from '../../components/Carousel';
import { Service } from '../../components/ServiceV2';
import { selectAddFormLink } from '../../selectors/addFormLink';
import { selectServices } from '../../selectors/services';
import { trackAddAdvClick } from '../AddOfferButtonContainer/analytics';
import { useApplicationContext } from '../ApplicationContext';

export const ServicesV4Container: React.FC = () => {
  const { config } = useApplicationContext();
  const services = useSelector(selectServices);
  const addFormLink = useSelector(selectAddFormLink);

  const addOfferButtonEnabled = config.get('mobileMainpage.addOfferButtonEnabled');

  if (!addOfferButtonEnabled && !services.length) {
    return null;
  }

  return (
    <Carousel isRedesign={true}>
      {addOfferButtonEnabled && (
        <Service
          key="place-offer-button"
          title="Разместить объявление"
          url={addFormLink}
          image={placeOffer}
          onClick={trackAddAdvClick}
        />
      )}
      {services.map(({ key, title, url, image }) => (
        <Service
          key={`service-${key}`}
          title={title}
          url={url}
          image={image}
          onShow={() => trackServiceShowNew(key)}
          onClick={() => trackServiceClick(key, true)}
        />
      ))}
    </Carousel>
  );
};
